/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_SubtitleInputs */

const en_visa_eb4_subtitle = /** @type {(inputs: Visa_Eb4_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPECIAL IMMIGRANTS`)
};

const pt_visa_eb4_subtitle = /** @type {(inputs: Visa_Eb4_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IMIGRANTES ESPECIAIS`)
};

const es_visa_eb4_subtitle = /** @type {(inputs: Visa_Eb4_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`INMIGRANTES ESPECIALES`)
};

/**
* | output |
* | --- |
* | "SPECIAL IMMIGRANTS" |
*
* @param {Visa_Eb4_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_subtitle = /** @type {((inputs?: Visa_Eb4_SubtitleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_SubtitleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_subtitle(inputs)
	if (locale === "es") return es_visa_eb4_subtitle(inputs)
	return en_visa_eb4_subtitle(inputs)
});